import { MaterialUICore } from '@iclinic/design-system';

const { styled } = MaterialUICore;

export const ImageIcon = styled('img')(() => ({
  display: 'inline-flex',
  verticalAlign: 'bottom',
}));
